"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DOCUMENT_TYPES = __importStar(require("./types"));

exports.default = [DOCUMENT_TYPES.ADDITION, DOCUMENT_TYPES.AMENDMENT, DOCUMENT_TYPES.CERTIFICATE_OF_COMPLETION, DOCUMENT_TYPES.CERTIFICATE_OF_COUNSELING, DOCUMENT_TYPES.CREDIT_REPORT, DOCUMENT_TYPES.JUDGMENT, DOCUMENT_TYPES.MEDICAL_RECORD, DOCUMENT_TYPES.PACKET_FILING, DOCUMENT_TYPES.PAY_DAY_LOAN, DOCUMENT_TYPES.PAY_STUB, DOCUMENT_TYPES.PETITION, DOCUMENT_TYPES.TAX_RETURN, DOCUMENT_TYPES.UTILITY];